import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommercePerformanceAction from '../actions/ecommerce-performance.action';
import * as EcommercePerformanceNowAction from '../actions/ecommerce-performance-now.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommercePerformance} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {LoadEcommercePerformanceNow} from "../actions/ecommerce-performance-now.action";
@Injectable()
export class EcommercePerformanceEffect {

  loadEcommercePerformance = createEffect(() => this._actions$.pipe(
    ofType(EcommercePerformanceAction.LOAD_ECOMMERCE_PERFORMANCE),
    mergeMap((action: LoadEcommercePerformance) => {
      const {websiteId} = action.payload;
      const datePicker = action?.payload?.datePicker;
      const forceCharge = action?.payload?.forceCharge;
      return this._ecommerceService.getTotalStats(websiteId, datePicker, forceCharge)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommercePerformanceAction.LoadEcommercePerformanceSuccess({
                data: response?.data?.dataKey,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePerformanceAction.LoadEcommercePerformanceFail({websiteId});
          })
        );
    })
  ));



    loadEcommercePerformanceToday = createEffect(() => this._actions$.pipe(
        ofType(EcommercePerformanceNowAction.LOAD_ECOMMERCE_PERFORMANCE_NOW),
        mergeMap((action: LoadEcommercePerformanceNow) => {
            const {websiteId} = action.payload;
            const datePicker = action?.payload?.datePicker;
            const forceCharge = action?.payload?.forceCharge;
            return this._ecommerceService.getTotalStats(websiteId, datePicker, forceCharge)
                .pipe(
                    filter((response: DbResponse) => !!response),
                    map((response: DbResponse) => {
                        if (response.success && response?.data) {
                            return new EcommercePerformanceNowAction.LoadEcommercePerformanceNowSuccess({
                                dataForToday: response?.data?.dataKey,
                                websiteId: websiteId,
                                loaded: true
                            });
                        }
                        return new EcommercePerformanceNowAction.LoadEcommercePerformanceNowFail({websiteId});
                    })
                );
        })
    ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
